export default {
    createDetailRow(key, info, $sourceRow) {
        const prefix = this.getSpacerPrefix(key);
        const $topSpacer = this.createSpacerRow(`spacer-top-${prefix}`);
        const $row = this.createDetailRowElement(key);
        const $cell = this.createDetailCell(key, info, $sourceRow);
        const $bottomSpacer = this.createSpacerRow(`spacer-bottom-${prefix}`);
        $row.append($cell);
        return { topSpacer: $topSpacer, detailRow: $row, bottomSpacer: $bottomSpacer };
    },

    createSpacerRow(id) {
        if (this.useDivGrid) {
            return $('<div>')
                .addClass('spacer-row data-grid-spacer')
                .attr('id', id)
                .css('display', 'none');
        }
        return $('<tr>')
            .addClass('spacer-row')
            .attr('id', id)
            .attr('data-dt-row', 'excluded')
            .css('display', 'none')
            .append($('<td>').attr('colspan', this.COLSPAN));
    },

    createDetailRowElement(key) {
        const id = this.getDetailRowId(key);
        const attrs = { id, 'data-expandable-type': key.type, 'data-expandable-id': key.id };
        if (this.useDivGrid) {
            return $('<div>')
                .addClass('data-grid-detail-row expandable-detail-row data-grid-detail')
                .attr(attrs)
                .css('display', 'none');
        }
        return $('<tr>')
            .addClass('data-grid-detail-row expandable-detail-row')
            .attr(attrs)
            .attr('data-dt-row', 'excluded')
            .css('display', 'none');
    },

    createDetailCell(key, info, $sourceRow) {
        const $cell = this.createCellElement();
        const $content = this.createDetailContent(key, info, $sourceRow);
        $cell.append($content);
        return $cell;
    },

    createCellElement() {
        if (this.useDivGrid) {
            return $('<div>').addClass('data-grid-detail-cell');
        }
        return $('<td>')
            .attr('colspan', this.COLSPAN)
            .addClass('data-grid-detail-cell');
    },

    createDetailContent(key, info, $sourceRow) {
        const $content = $('<div>').addClass('data-grid-detail-content');
        const $rowContainer = $('<div>').addClass('row');
        $content.append(this.createActionButtonsSection(key, $sourceRow));
        if (key.type === 'pledge') {
            $rowContainer.attr({ 'data-expand-content': '', 'data-pledge-id': key.id, 'data-table-name': key.tableName || '' });
            if (this.portal === 'member') {
                $rowContainer.addClass('member-pledge-expand-no-content');
            } else {
                this.setLoadingState($rowContainer, 'Loading...');
            }
        } else {
            $rowContainer.attr({ 'data-expand-content': '', 'data-member-id': key.id });
            this.setLoadingState($rowContainer, 'Loading...');
        }
        $content.append($rowContainer);
        return $content;
    },
};
